import { createSelector } from 'reselect';
import { NAME } from './constants';

export const getModel = state => state[NAME];

/** activeElement **/
export const getActiveElementModel = createSelector(
    getModel,
    (model) => model.activeElement
);

/** activeElement **/
export const getActiveElement = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.data
);
export const getIsFetchingElement = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.isFetching
);
export const getActiveLaminates = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.activeLaminates
);
export const getIsSavingActiveLaminates = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.isSavingActiveLaminates
);
export const getActiveAccessories = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.activeAccessories
);
export const getIsSavingActiveAccessories = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.isSavingActiveAccessories
);
export const getDiscountTable = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.discountTable
);
export const getIsSavingDiscountTable = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.isSavingDiscountTable
);

/** form **/
export const getForm = createSelector(
    getModel,
    (model) => model.form
);
export const getFormValues = createSelector(
    getForm,
    (form) => form.formValues
);
export const getIsSavingForm = createSelector(
    getForm,
    (form) => form.isSaving
);
export const getFormErrors = createSelector(
    getForm,
    (form) => form.formErrors
);
export const getFormErrorsMessages = createSelector(
    getForm,
    (form) => form.formErrorMessages
);

/** elements **/
export const getElements = createSelector(
    getModel,
    (model) => model.elements.data
);
export const getProcessedElements = createSelector(
    getModel,
    (model) => model.elements.processedElements
);
export const getIsFetchingElements = createSelector(
    getModel,
    (model) => model.elements.isFetching
);

/** delete **/
export const getIsDeleting = createSelector(
    getModel,
    (model) => model.delete.isDeleting
);
export const getIdForDelete = createSelector(
    getModel,
    (model) => model.delete.id
);

/** pagination **/
export const getTotalItems = createSelector(
    getModel,
    (model) => model.pagination.totalItems
);
export const getTotalPages = createSelector(
    getModel,
    (model) => model.pagination.totalPages
);
export const getSelectedPage = createSelector(
    getModel,
    (model) => model.pagination.selectedPage
);
export const getElementsPerPage = createSelector(
    getModel,
    (model) => model.pagination.elementsPerPage
);

/** sort **/
export const getSortColumn = createSelector(
    getModel,
    (model) => model.sort.column
);
export const getSortType = createSelector(
    getModel,
    (model) => model.sort.type
);

/** information **/
export const getIsFetchingInformation = createSelector(
    getModel,
    (model) => model.information.isFetching
);
export const getLaminates = createSelector(
    getModel,
    (model) => model.information.laminates
);
export const getAccessories = createSelector(
    getModel,
    (model) => model.information.accessories
);

/** filter **/
export const getFilterFields = createSelector(
    getModel,
    (model) => model.filter.fields
);
